var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.875V10.625C0 11.2344 0.515625 11.75 1.125 11.75H2.25V2.75H1.125C0.515625 2.75 0 3.28906 0 3.875ZM7.875 0.5H4.125C3.51562 0.5 3 1.03906 3 1.625V11.75H9V1.625C9 1.03906 8.46094 0.5 7.875 0.5ZM7.875 2.75H4.125V1.625H7.875V2.75ZM10.875 2.75H9.75V11.75H10.875C11.4609 11.75 12 11.2344 12 10.625V3.875C12 3.28906 11.4609 2.75 10.875 2.75Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserId);
export default __webpack_public_path__ + "static/media/UserId.ec36ea361114ec1c3bc6b92c18ce88ec.svg";
export { ForwardRef as ReactComponent };